// The existing accent picker uses legacy IDs for American and Indian English.
export function ersSpeechLanguage (accent) {
  const aliases = { 'en-EN': 'en-US', 'it-IT': 'en-IN' }
  return aliases[accent] || accent || 'en-US'
}
